export default function ChangeAmountOnlyNumber(input) {
  const pattern = /(\s|[A-Za-zА-Яа-я]|\,|\-|\+|\$|\=|\(|\)|\*|\&|\*|\^|\%|\#|\@|\!|\~|\_|\<|\>|\"|\'|\||\?|\/|\[|\]|\{|\}|\\)/g;
  let amount = input.value.replace(pattern, '');

  input.value = amount;
}
